// @flow
/* eslint-disable import/prefer-default-export */
import { ApolloError } from '@apollo/client';

const reSegmentAlreadyExistsErrorMessage =
  /(Segment \[.*] already exists for \[\d+]|DUPLICATE_SEGMENT_NAME)/;
export class SegmentAlreadyExists extends Error {
  constructor() {
    super('Segment already exists.');
    // @FIXME work-around for babel 6
    // $FlowFixMe - horrible work-around
    this.constructor = SegmentAlreadyExists;
    // $FlowFixMe - horrible work-around
    this.__proto__ = SegmentAlreadyExists.prototype; // eslint-disable-line no-proto
  }
}

const reSegmentAllocationExceedsMaximum =
  /(Total segmented value \[[-0-9.]+] exceeds data entry amount \[[-0-9.]+]|ALLOCATION_OVER_MAXIMUM)/;
export class SegmentAllocationExceedsMaximum extends Error {
  constructor() {
    super('Allocation exceeds the total amount of the data entry.');
    // @FIXME work-around for babel 6
    // $FlowFixMe - horrible work-around
    this.constructor = SegmentAllocationExceedsMaximum;
    // $FlowFixMe - horrible work-around
    this.__proto__ = SegmentAllocationExceedsMaximum.prototype; // eslint-disable-line no-proto
  }
}

export function wrapKnownErrors(error: ApolloError) {
  if (error.networkError) {
    const { statusCode, result } = error.networkError;
    if (statusCode === 400) {
      if (result.messages.some(({ message }) => reSegmentAlreadyExistsErrorMessage.test(message))) {
        throw new SegmentAlreadyExists();
      }
      if (result.messages.some(({ message }) => reSegmentAllocationExceedsMaximum.test(message))) {
        throw new SegmentAllocationExceedsMaximum();
      }
    }
  }
  throw error;
}
